import React, { forwardRef } from 'react';
import { useIntl } from 'react-intl';
import { FilterIcon } from '@panwds/icons';
import { classNames, LoadingIcon, Tooltip } from '@panwds/react-ui';

const AddButton = forwardRef(({ disabled, isLoading, showLabel = false, dataMetrics, dataTestId, isOpen, addFilterLabel, ...rest }, ref) => {
    const intl = useIntl();
    const buttonClasses = classNames("tw-box-border tw-rounded focus:tw-outline-none focus:tw-bg-blue-100 tw-flex tw-items-center tw-space-x-2 tw-text-blue-600 tw-leading-6", "tw-border-0 tw-group tw-bg-transparent tw-text-link dark:tw-text-blue-400 active:tw-text-blue-800 dark:active:tw-text-blue-200 active:tw-bg-blue-200 dark:active:tw-bg-blue-600 focus-visible:tw-bg-blue-100 dark:focus-visible:tw-bg-blue-700 focus-visible:tw-text-blue-700 dark:focus-visible:tw-text-blue-300", "tw-text-xs tw-font-lato tw-font-semibold", disabled
        ? "tw-opacity-40 tw-cursor-not-allowed"
        : "hover:tw-text-blue-700 dark:hover:tw-text-blue-300 hover:tw-bg-blue-100 dark:hover:tw-bg-blue-700 tw-cursor-pointer");
    const textClasses = classNames(isLoading
        ? "tw-text-default dark:tw-text-dark-bg"
        : disabled
            ? "tw-text-disabled dark:tw-text-dark-bg-disabled tw-cursor-not-allowed"
            : "tw-text-link dark:tw-text-blue-400");
    const label = disabled
        ? intl.formatMessage({ id: "+0hcL4", defaultMessage: [{ type: 0, value: "Filters are disabled" }] })
        : addFilterLabel ||
            intl.formatMessage({ id: "GVFFft", defaultMessage: [{ type: 0, value: "Add Filter" }] });
    const AddIcon = () => (React.createElement("span", { className: "tw-mr-2 tw-mt-1" },
        React.createElement(FilterIcon, { size: "sm" })));
    if (showLabel || isLoading) {
        return (React.createElement("button", { className: buttonClasses, ref: ref, ...rest, type: "button", disabled: disabled, "data-metrics": `${dataMetrics}`, "data-testid": dataTestId || `button-add-filter` },
            React.createElement(AddIcon, null),
            React.createElement("span", { className: textClasses }, isLoading ? (React.createElement(React.Fragment, null,
                React.createElement(LoadingIcon, { size: "lg", className: "tw-mr-2 tw-animate-spin" }),
                intl.formatMessage({ id: "VHbZhY", defaultMessage: [{ type: 0, value: "Loading" }] }))) : (label))));
    }
    return (React.createElement("span", { ref: ref, ...rest },
        React.createElement(Tooltip, { label: label, "data-tooltip": isOpen },
            React.createElement("button", { "aria-label": label, className: buttonClasses, disabled: disabled, "data-testid": dataTestId || `add-filter`, "data-metrics": `${dataMetrics}`, type: "button" },
                React.createElement(AddIcon, null),
                addFilterLabel ||
                    intl.formatMessage({ id: "TA7r+x", defaultMessage: [{ type: 0, value: "Add Filter" }] })))));
});
AddButton.displayName = "AddButton";

export { AddButton };
//# sourceMappingURL=AddButton.esm.js.map
